import { useEffect, useRef } from 'react';

export const useLazyLoading = ({ target = 'src', value = '' }) => {
  const elRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            el.setAttribute(target, value);
            observer.unobserve(el);
          }
        });
      },
      {
        rootMargin: '0px',
        threshold: 0.5,
      }
    );

    if (elRef.current) {
      observer.observe(elRef.current);
    }

    return () => {
      if (elRef.current) {
        observer.unobserve(elRef.current);
      }
    };
  }, [value]);

  return elRef;
};